"use client";
import * as React from "react";
const SvgBackspaceSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 0H4L0 6l4 6h12zm-3.33 8.4-.94.93-2.4-2.39-2.39 2.4L6 8.38 8.4 6 6 3.6l.94-.93 2.4 2.39 2.39-2.4.94.95L10.27 6z" }));
export {
  SvgBackspaceSharp as default
};
